import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth uses secure HttpOnly cookies — send credentials on every request.
// No tokens are ever stored in localStorage/sessionStorage.
const api = axios.create({ baseURL: API, withCredentials: true });

function readCookie(name) {
  const match = document.cookie.match(new RegExp("(^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[2]) : "";
}

// Double-submit CSRF: echo the readable vm_csrf cookie back on state-changing requests.
api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const token = readCookie("vm_csrf");
    if (token) config.headers["X-CSRF-Token"] = token;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Er ging iets mis. Probeer het opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatPrice(value) {
  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/a56a88d5-5002-4149-9fbd-2da948c59545/images/2cdad99ba1446772507b89a7bc45c034cdc181a681c23b5dbe0a2e4a89ba1c7e.jpeg";

export const CONDITIONS = [
  { value: "nieuw", label: "Nieuw" },
  { value: "zo-goed-als-nieuw", label: "Zo goed als nieuw" },
  { value: "gebruikt", label: "Gebruikt" },
  { value: "refurbished", label: "Refurbished" },
];

export const DELIVERY = [
  { value: "ophalen", label: "Ophalen" },
  { value: "verzenden", label: "Verzenden" },
  { value: "beide", label: "Ophalen of verzenden" },
];

export const conditionLabel = (v) => (CONDITIONS.find((c) => c.value === v)?.label || v);
export const deliveryLabel = (v) => (DELIVERY.find((c) => c.value === v)?.label || v);

// Return a right-sized image URL for a given render width. The Unsplash image CDN
// supports on-the-fly resizing via query params, which turns multi-MB full-res
// originals into small, fast thumbnails. Base64 data URLs (user uploads) and other
// hosts are returned unchanged.
export function thumbUrl(url, width = 600) {
  if (!url || typeof url !== "string" || url.startsWith("data:")) return url;
  if (url.includes("images.unsplash.com")) {
    const [base, query = ""] = url.split("?");
    const params = new URLSearchParams(query);
    params.set("w", String(width));
    params.set("q", "70");
    params.set("auto", "format");
    params.set("fit", "crop");
    return `${base}?${params.toString()}`;
  }
  return url;
}

export default api;
